export const profileData = {
  name: "Aditya Sonthalia",
  title: "Growth Product Manager",
  tagline: "Building products at the intersection of data, growth, and strategy.",
  bio: "I'm a product manager with a deep passion for turning data into decisions and ambiguity into action. From scaling a startup's revenue 14x at FRND to risk modeling at Goldman Sachs — I thrive at the intersection of product, analytics, and strategy. Currently at GoodScore, owning onboarding & subscription retention.",
  location: "Bengaluru, India",
  email: "adisonth98@gmail.com",
  linkedin: "https://www.linkedin.com/in/aditya-sonthalia",
  resumeUrl: "https://customer-assets.emergentagent.com/job_career-canvas-157/artifacts/jwjfnupu_ADITYA%20SONTHALIA.pdf",
  keyAreas: ["Product", "Analytics", "Strategy"]
};

export const companyLogos = {
  "IIT Kanpur": {
    url: "https://customer-assets.emergentagent.com/job_career-canvas-157/artifacts/s9l428lg_image.png",
    bg: "#0a0a0a",
    padding: 3,
    cover: false
  },
  "Goldman Sachs": {
    url: "https://customer-assets.emergentagent.com/job_career-canvas-157/artifacts/7or7w0ng_image.png",
    bg: "#ffffff",
    padding: 5,
    cover: false
  },
  "FRND": {
    url: "https://customer-assets.emergentagent.com/job_career-canvas-157/artifacts/p5il4o9q_frnd_logo.webp",
    bg: "transparent",
    padding: 0,
    cover: true
  },
  "GoodScore": {
    url: "https://customer-assets.emergentagent.com/job_career-canvas-157/artifacts/cafx08vh_goodscore_logo.png",
    bg: "transparent",
    padding: 0,
    cover: true
  },
  "Vox Populi": {
    url: "https://customer-assets.emergentagent.com/job_career-canvas-157/artifacts/q04bg3wr_vox_populi_iit_kanpur_logo.jpeg",
    bg: "#ffffff",
    padding: 4,
    cover: false
  }
};

export const experiences = [
  {
    id: 1,
    company: "GoodScore",
    type: "single",
    role: "Growth Product Manager",
    period: "Dec 2025 – Present",
    location: "Bengaluru",
    current: true,
    description: "Owning Onboarding & Subscription Retention charters, driving user activation and long-term engagement.",
    bullets: [
      "Owning onboarding charter — improving activation funnel conversion and time-to-value for new users",
      "Driving subscription retention strategies to reduce churn and improve LTV",
      "Partnering with data, design, and engineering for iterative growth experiments"
    ],
    tags: ["Growth", "Retention", "Onboarding"]
  },
  {
    id: 2,
    company: "FRND",
    type: "multi",
    overallPeriod: "Apr 2023 – Nov 2025",
    location: "Bengaluru",
    current: false,
    roles: [
      {
        role: "Revenue Lead",
        period: "Aug 2024 – Nov 2025",
        description: "Scaled revenue from $3.6M to $50M ARR (~14x) through rapid cross-functional execution.",
        bullets: [
          "Scaled revenue from $3.6M to $50M ARR (~14x) through rapid cross-functional execution",
          "Led FRND iOS launch & international expansion (Middle East, UK), driving 20% of monthly revenue",
          "Increased whale users (>1000/month) from 3% to 11% via churn modeling and matching algorithm improvements",
          "Founded the Strategy team, leading 6 A-players with independent charters",
          "Launched Soul — an AI companion app scaled to 10k DAU and Rs 10L monthly run-rate in 3 months",
          "Built internal SQL bot, marketing spend allocation model and CAC-reduction workflows using Claude Code"
        ],
        tags: ["Revenue Growth", "AI Products", "Strategy", "Team Leadership"]
      },
      {
        role: "Associate Product Manager",
        period: "Dec 2023 – Jul 2024",
        description: "Launched new product SKUs, improved creator monetization, and bypassed Play Store's 30% cut.",
        bullets: [
          "Achieved 100% video call moderation coverage by integrating Hive AI, reducing NSFW calls from 11% to 2%",
          "Launched two new SKUs (Star Trainers and Loveskool), now driving 30% of daily revenue",
          "Shifted 75%+ of in-app revenue to website payments, bypassing Play Store's 30% commission",
          "Improved creator onboarding conversion (registration to earning %) from 14% to 51%",
          "Managed monthly investor reporting (MIS) for Elevation Capital, IndiaQuotient, and Krafton"
        ],
        tags: ["Monetization", "AI Moderation", "UX", "Investor Relations"]
      },
      {
        role: "Product Analyst",
        period: "Apr 2023 – Nov 2023",
        description: "Drove data infrastructure, fraud prevention, and payment stack improvements end-to-end.",
        bullets: [
          "Reduced inactive call time from 26% to 11% via inactivity detection mechanisms",
          "Deplatformed 6000+ fraudulent users by embedding a PAN-Bank-UPI KYC ecosystem",
          "Increased in-app payment success rate from 18% to 53% with three-gateway dynamic routing",
          "Cut median payment status latency from 31s to 14s by streamlining backend workflows",
          "Reduced annual liability by ~60L via a KYC-based TDS deduction flow",
          "Built and maintained 30+ dashboards across Google Sheets, Metabase and BigQuery"
        ],
        tags: ["Analytics", "Payments", "KYC", "Dashboards"]
      }
    ]
  },
  {
    id: 3,
    company: "Goldman Sachs",
    type: "single",
    role: "Analyst, Consumer Finance Strats",
    period: "Jun 2021 – Feb 2023",
    location: "Bengaluru",
    current: false,
    description: "Built financial models for forecasting, risk management, and regulatory compliance.",
    bullets: [
      "Achieved 45% improvement in forecasting accuracy via scalable cashflow projection models",
      "Delivered 52% reduction in reserve costs by optimizing funding bond booking strategies",
      "Built a Net Interest Income projection model for CCAR regulatory stress testing",
      "Developed automated risk infrastructure for balance flows, interest income, and expense management"
    ],
    tags: ["Financial Modeling", "Risk Management", "CCAR", "Forecasting"]
  }
];

export const skills = [
  {
    category: "Product",
    items: ["Product Strategy", "Roadmapping", "A/B Testing", "User Research", "Monetization", "Growth Loops", "SKU Development"]
  },
  {
    category: "Analytics",
    items: ["SQL", "BigQuery", "Metabase", "Google Sheets", "Data Visualization", "Funnel Analysis", "Cohort Analysis"]
  },
  {
    category: "Strategy",
    items: ["Revenue Scaling", "International Expansion", "Market Analysis", "CAC Reduction", "Investor Reporting", "Business Intelligence"]
  },
  {
    category: "Technical",
    items: ["AI Integration", "Payment Gateways", "KYC Systems", "Automation", "Prompt Engineering", "Workflow Optimization"]
  },
  {
    category: "Leadership",
    items: ["Team Building", "Cross-functional Execution", "Stakeholder Management", "Mentoring", "Editorial Direction"]
  }
];

export const education = [
  {
    id: 1,
    institution: "Indian Institute of Technology, Kanpur",
    degree: "B.Tech in Mathematics & Scientific Computing",
    period: "2017 – 2021",
    grade: "CGPA: 8.1",
    description: "One of India's most prestigious engineering institutions. Specialized in mathematical modeling, statistical computing, and algorithmic problem-solving."
  }
];

export const leadership = [
  {
    id: 1,
    organization: "Vox Populi, IIT Kanpur",
    role: "Chief Editor",
    period: "2018 – 2021",
    bullets: [
      "Directed a 60+ member journalism body, creating editorial workflows and content strategies",
      "Surveyed 3,200+ students on COVID-19 academic policy — findings shaped institutional decisions",
      "Led mental health discourse survey of 1,200+ students; findings referenced by NUJS, Kolkata",
      "Expanded multimedia portfolio — revived comics, video, animation and satire wings; produced 40+ editions"
    ]
  }
];

export const writings = [
  {
    id: 1,
    title: "The Infrastructure of Trust: How KYC shaped FRND's creator economy",
    description: "A deep-dive into building KYC systems inside a social platform and what it means for creator monetization.",
    tag: "Product",
    year: "2024"
  },
  {
    id: 2,
    title: "From 3% to 11%: Building a whale user engine",
    description: "How we identified, modeled, and retained high-value users on a live social platform using data and product thinking.",
    tag: "Growth",
    year: "2024"
  },
  {
    id: 3,
    title: "Why I stopped using the Play Store for payments",
    description: "A product manager's case for rethinking app store dependency in monetization strategy.",
    tag: "Strategy",
    year: "2023"
  }
];
